 <form [formGroup]="interpreterDetailsForm">
    <div class="p-grid dashed-line p-my-4"></div>

    <div class="p-grid p-my-2">
        <div class="p-col-12">
            <label class="label-large-bold">Petition Interpreter Information</label>
        </div>
        <div class="p-col-4" name="question">
            Do you want to include interpreter?
        </div>
        <div class="p-col-1" id="element_interpreter">
            <p-inputSwitch [(ngModel)]="isIncludeInterpreter" [ngModelOptions]=" 
            {standalone: true}" (onChange)="includeInterpreter($event)"></p-inputSwitch>
        </div>
    </div>

    <div class="p-fluid p-formgrid p-grid" *ngIf="isIncludeInterpreter">

        <div class="p-col-4">
            <label for="_languagesList" class="create-task-label mb-0 required">Interpreting Language</label>
            <p-dropdown inputId="_languagesList" formControlName="interpreterLangId" [options]="languagesList"
                placeholder="Select language" optionLabel="name" optionValue="id" (onChange)="onLanguageChange($event)" appendTo="body">
            </p-dropdown>
            <span class="invalid-message"
                *ngIf="interpreterDetailsForm.get('interpreterLangId').touched  && interpreterDetailsForm.get('interpreterLangId').invalid">Please select language.</span>
        </div>

        <div class="p-col-4">
            <label for="_interpreterName" class="create-task-label mb-0 required">Interpreter Name</label>
            <p-dropdown inputId="_interpreterName" formControlName="interpreterId" [options]="interpreterList" placeholder="Select interpreter" optionLabel="name" optionValue="id" (onChange)="onInterpreterChange($event)" appendTo="body">
            </p-dropdown>
            <span class="invalid-message"
                *ngIf="interpreterDetailsForm.get('interpreterId').touched  && interpreterDetailsForm.get('interpreterId').invalid">Please select interpreter.</span>
        </div>

        <!-- <div class="p-col-4">{{interpreterDetailsForm.get('interpreterLanguageId').value}}</div> -->

    </div>
</form>